import React from 'react';
import { Card, Empty, Table } from 'antd';
import ReactApexChart from 'react-apexcharts';
import { TASK_STATUS_COLORS } from '../../constants';

const TaskOverview = ({ title, data, total, showHeader = true }) => {
  const getCategoryColor = (category) => {
    switch (category?.toLowerCase()) {
      case 'unassigned':
        return TASK_STATUS_COLORS.unassigned;
      case 'pending':
        return TASK_STATUS_COLORS.pending;
      case 'completed':
        return TASK_STATUS_COLORS.completed;
      case 'overdue':
        return TASK_STATUS_COLORS.overdue;
      case 'scheduled':
        return TASK_STATUS_COLORS.scheduled;
      default:
        return '#000';
    }
  };

  const chartColors = data?.map((task) => getCategoryColor(task.category)) || [];

  const chartOptions = {
    chart: {
      type: 'donut',
    },
    labels: data?.map((task) => task.category),
    colors: chartColors,
    legend: {
      show: false,
      position: 'bottom',
    },
    dataLabels: {
      enabled: false,
      formatter: (val) => `${val.toFixed(1)}%`,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total',
              fontSize: '16px',
              color: '#000',
              fontWeight: 'bold',
              formatter: () => Number(total ?? 0),
            },
          },
        },
      },
    },
  };

  const chartSeries = data?.map((task) => Number(task?.count));

  const columns = [
    {
      title: 'Status',
      dataIndex: 'category',
      key: 'category',
      render: (text, record, index) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span
            style={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              backgroundColor: chartOptions.colors[index],
              display: 'inline-block',
              marginRight: 8,
            }}
          />
          {text}
        </div>
      ),
    },
    {
      title: 'Tasks',
      dataIndex: 'count',
      key: 'count',
      align: 'right',
    },
  ];

  return (
    <Card
      title={title}
      style={{ borderRadius: 8 }}
      styles={{
        body: { padding: 16 },
      }}
    >
      {parseInt(total) === 0 ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <ReactApexChart options={chartOptions} series={chartSeries} type="donut" width={250} />
          </div>
          <Table
            showHeader={showHeader}
            columns={columns}
            dataSource={data}
            pagination={false}
            size="small"
            rowKey="category"
            components={{
              header: {
                cell: (props) => (
                  <th
                    {...props}
                    style={{
                      ...props.style,
                      background: 'transparent',
                    }}
                  />
                ),
              },
            }}
          />
        </>
      )}
    </Card>
  );
};

export default TaskOverview;
